import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { LanguageProvider } from "./contexts/LanguageContext";
import { CartProvider } from "./contexts/CartContext";
import { ConsentProvider } from "./contexts/ConsentContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import ScrollToTop from "./components/ScrollToTop";
import MesureAudience from "./components/MesureAudience";
import BanniereConsentement from "./components/BanniereConsentement";
import WhatsAppButton from "./components/WhatsAppButton";
import ChatWidget from "./components/ChatWidget";

// Pages
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Delivery from "./pages/Delivery";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Checkout from "./pages/Checkout";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";
const AdminPanel = lazy(() => import("./pages/AdminPanel"));
import Downloads from "./pages/Downloads";
import MentionsLegales from "./pages/MentionsLegales";
import CGV from "./pages/CGV";
import Confidentialite from "./pages/Confidentialite";
import Desinscription from "./pages/Desinscription";

function AppContent() {
  return (
    <div className="App min-h-screen bg-background">
      <ScrollToTop />
      <MesureAudience />
      <Header />
      <CartDrawer />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:productId" element={<ProductDetail />} />
          <Route path="/delivery" element={<Delivery />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/checkout/cancel" element={<CheckoutCancel />} />
          <Route path="/admin" element={
            <Suspense fallback={<div className="min-h-screen flex items-center justify-center text-sm text-gray-500">Chargement du back-office…</div>}>
              <AdminPanel />
            </Suspense>
          } />
          <Route path="/downloads" element={<Downloads />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/desinscription" element={<Desinscription />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppButton />
      <ChatWidget />
      <BanniereConsentement />
      {/* offset : décale les notifications sous l'en-tête (64px mobile / 80px
          desktop), sinon elles recouvrent l'icône du panier juste après un ajout. */}
      <Toaster
        position="top-right"
        richColors
        offset="96px"
        mobileOffset="76px"
        toastOptions={{
          style: {
            fontFamily: 'Outfit, sans-serif',
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <LanguageProvider>
          <ConsentProvider>
            <CartProvider>
              <AppContent />
            </CartProvider>
          </ConsentProvider>
        </LanguageProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
